export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_16.54a68596.mp4";